import { useState } from 'react'
import { isValid } from 'date-fns'

import { useTheme } from '@mui/material'
import {
  DatePicker,
  DatePickerProps,
  DateValidationError,
  LocalizationProvider
} from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { FieldChangeHandler } from '@mui/x-date-pickers/internals'

type Props = {
  label: string
  value: Date | null
  onChange: (date: Date | null) => void
  maxDate?: Date
} & DatePickerProps

export const DateSelect = ({ label, value, onChange, maxDate, ...props }: Props) => {
  const [open, setOpen] = useState(false)
  const theme = useTheme()
  const handleChange: FieldChangeHandler<Date | null, DateValidationError> = (date) => {
    setOpen(false)

    if (!isValid(date)) {
      return
    }

    onChange(date)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={value}
        open={open}
        onChange={handleChange}
        format="dd MMM yyyy"
        maxDate={maxDate}
        onClose={() => setOpen(false)}
        slotProps={{
          textField: {
            size: 'small',
            sx: {
              backgroundColor: theme.palette.background.paper,
              borderRadius: Number(theme.shape.borderRadius) / 4
            }
          },
          openPickerButton: {
            onClick: (e: React.MouseEvent) => {
              e.stopPropagation()
              setOpen(true)
            }
          }
        }}
        {...props}
      />
    </LocalizationProvider>
  )
}
